import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { RESET } from 'jotai/utils';
import { MouseEvent, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { atomInfoCampaignV1 } from '@/modules/CampaignsModule/atoms/campaignAtom';
import {
  atomFiltersRecurrent,
  atomHistorySearchPagerRecurrent,
  atomPagerCampaignsRecurrent,
} from '@/modules/CampaignsModule/atoms/campaignRecurrentAtom';
import { atomToggleEditCreateCampaignModal } from '@/modules/CampaignsModule/atoms/modalsCampaignAtom';
import { atomHistorySearchPagerActions } from '@/modules/CampaignsModule/atoms/recurrentActionsAtom';
import { CAMPAIGNS_RECURRENT_PATH, defaultPager } from '@/modules/CampaignsModule/constants';
import { useCampaignRecurrentFilters } from '@/modules/CampaignsModule/hooks/useCampaignRecurrentFilters';
import {
  IRecurrenceMessage,
  ITableCampaignsRecurrent,
  ITablePager,
} from '@/modules/CampaignsModule/interfaces/Campaigns';

export const useHandleEvents = () => {
  const navigate = useNavigate();

  const [pager, setPageParams] = useAtom(atomPagerCampaignsRecurrent);
  const setInfoCampaignV1 = useSetAtom(atomInfoCampaignV1);
  const filters = useAtomValue(atomFiltersRecurrent);

  const setToggleEditCategoryModal = useSetAtom(atomToggleEditCreateCampaignModal);
  const setHistorySearchPagerCampaign = useSetAtom(atomHistorySearchPagerRecurrent);
  const setHistorySearchPagerAction = useSetAtom(atomHistorySearchPagerActions);

  /*
  //TODO: Delete this after refactor
  const { resetFilters } = useFiltersRecurrent();
   */
  const { getRecurrentCampaigns, resetFilters } = useCampaignRecurrentFilters();

  const handleClickEmptyScreen = useCallback(() => {
    setToggleEditCategoryModal(true);
  }, [setToggleEditCategoryModal]);

  const handleClickEmptyScreenNoResult = useCallback(() => {
    resetFilters();
  }, [resetFilters]);

  const handleChangeTablePage = useCallback(
    (payload?: ITablePager) => {
      const { pageIndex = 1, pageSize = 10 } = payload ?? {};
      const newLimit = pageSize;
      const newPage = pageIndex + 1;

      if (pager?.page !== newPage || pager?.limit !== newLimit) {
        setPageParams({ page: newPage, limit: newLimit });
        void getRecurrentCampaigns({
          ...filters,
          page: newPage,
          limit: newLimit,
        });
      }
    },
    [filters, pager, getRecurrentCampaigns, setPageParams]
  );

  const handleClickReport = useCallback(
    (event: MouseEvent<HTMLButtonElement>, value: IRecurrenceMessage) => {
      event.stopPropagation();
      navigate(`/v2/campaigns/${value.campaignId}/report`);
      setInfoCampaignV1({
        campaign: {
          id: Number(value?.campaignId),
          name: value?.name ?? '',
        },
      });
    },
    [navigate, setInfoCampaignV1]
  );

  const handleRowClick = useCallback(
    (value: ITableCampaignsRecurrent) => {
      const { campaignId } = value?.campaign || { campaignId: 0 };
      setHistorySearchPagerCampaign({
        filters: { ...filters },
        pager: {
          page: pager?.page || defaultPager.page,
          limit: pager?.limit || defaultPager.limit,
        },
      });
      setHistorySearchPagerAction(RESET);
      navigate(`${CAMPAIGNS_RECURRENT_PATH}/${campaignId}`);
    },
    [
      filters,
      navigate,
      pager?.limit,
      pager?.page,
      setHistorySearchPagerAction,
      setHistorySearchPagerCampaign,
    ]
  );

  return {
    handleChangeTablePage,
    handleClickReport,
    handleClickEmptyScreen,
    handleClickEmptyScreenNoResult,
    handleRowClick,
  };
};
